import { memo } from 'react';
import cn from 'classnames';
import Close from '../Icons/Close';
import './Alert.scss';

/**
 * 
 * @param {{
 *   variation?: 'big';
 *   onDismiss?: () => void;
 * }} param0 
 * @returns 
 */
const Alert = ({
  icon,
  children,
  title,
  className,
  variation,
  onDismiss,
}) => {
  const Icon = icon;

  return (
    <div className={cn('Alert', className, {
      [`Alert--${variation}`]: !!variation,
    })}>
      {onDismiss && (
        <Close className="Alert__Dismiss" onClick={onDismiss} />
      )}
      {icon && (
        <div className="Alert__Icon"><Icon /></div>
      )}
      <div className="Alert__Content">
        {title && <h4 className="Alert__Title">{title}</h4>}
        <p className="Alert__Text">{children}</p>
      </div>
    </div>
  );
}

export default memo(Alert);